<template lang="pug">
  header#header.pb-1.header-item-box.mx-auto
    b-container(fluid)
      b-row.form-box.mx-auto(:no-gutters="true")
        b-col.mt-3
          h3.mb-2
            img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
            | |
            img.ml-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
        b-col.text-right.d-flex.align-items-center.justify-content-end
          b-button.mr-2.btn-font-size(variant="info", :to={name: 'ContactInfo', hash: '#incident'})
            | 障害時のお問い合わせ
          p.font-weight-bold.mb-0 {{client_no}}：{{firm_name}} 様
</template>

<script>
export default {
  name: "HeaderForTopPage",
  props: {
    client_no: { type: String, require: true },
    firm_name: { type: String, require: true }
  }
}
</script>

<style scoped>
.logo_desknets {
  position: relative;
  width: 200px;
  bottom: 8px;
}
.logo_chatluck {
  position: relative;
  width: 200px;
  bottom: 5px;
}
.form-box {
  max-width: 1200px;
}
</style>